import { render, staticRenderFns } from "./SwInputAutocompletion.vue?vue&type=template&id=85bba1a4"
import script from "./SwInputAutocompletion.vue?vue&type=script&lang=js"
export * from "./SwInputAutocompletion.vue?vue&type=script&lang=js"
import style0 from "./SwInputAutocompletion.vue?vue&type=style&index=0&id=85bba1a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports